/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { switchOrgResponseV4Schema } from './switchOrgResponseV4Schema'

export const switchOrgResponseV4ApiResponseObjectV4Schema = z
  .object({
    ok: z.boolean().default(false),
    errorMsg: z.string().nullish(),
    redirectAction: z.unknown().nullish(),
    result: switchOrgResponseV4Schema.describe(
      'Result of switching the active org/role context: the re-issued token plus the identity for the new context.\r\nAlso returned when accepting an invitation, which switches into the joined org.'
    ),
  })
  .describe(
    'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
  )
